export class ImageSliderClass {
    constructor(slider) {
        this.slider = slider;
        this.bullets = this.slider.querySelectorAll('.o-image-slider__buttons');
        this.direction = document.querySelector('html').getAttribute('dir');
        this.overwriteDirection = document.querySelector('main').getAttribute('dir');
        this.slidesCount = this.bullets.length;

        if(!this.overwriteDirection){
            let productDetail = document.querySelector('div.c-products__detail');
            if(productDetail){
                this.overwriteDirection = document.querySelector('div.c-products__detail').getAttribute('dir');
            }
        }

        if(this.overwriteDirection){
            this.sliderDirection = this.overwriteDirection;
        } else {
            this.sliderDirection = this.direction;
        }

        if (this.slider) {
            this.init();
        }
    }
    init() {
        let _this = this;
        // init and configure glide.js
        this.glide = new Glide(this.slider, {
            type: 'carousel',
            gap: 0,
            perView: 1,
            direction: _this.sliderDirection,
            classes: {
                direction: {
                    ltr: 'dir-ltr',
                    rtl: 'dir-rtl'
                },
                slider: 'is-slider',
                carousel: 'is-carousel',
                swipeable: 'is-swipeable',
                dragging: 'is-dragging',
                cloneSlide: 'is-clone',
                activeNav: 'is-active',
                activeSlide: 'is-active',
                disabledArrow: 'is-disabled'
            }
        });
        if(this.slidesCount > 0){
            this.glide.on('mount.after', function () {
                _this.updateBullets();
            });
        }

        if(this.slidesCount > 0) {
            this.glide.on('resize', function () {
                _this.updateBullets(true);
            });
        }

        this.glide.on('run', () => {
            requestAnimationFrame(() => this.changeActiveBullet(this.glide.index, this.slider.querySelector('.glide__bullets')));
        });

        this.glide.mount();
    }

    updateBullets(reset = false) {
        if (reset) {
            this.currentStep = 0;
            this.glide.go('=0');
        }
        this.bullets.forEach((bullet, index) => {
            if (index === 0 || index % this.glide.settings.perView === 0) {
                bullet.style.display = 'flex';
                this.maxIndex = index;
            } else {
                bullet.style.display = 'none';
            }
        });
    }

    changeActiveBullet(newIndex, containerElement) {
        if(this.slidesCount > 0) {
            const activeBullet = 'glide__bullet--active';
            const glideDir = containerElement.querySelector(`[data-glide-dir="=${newIndex}"]`);

            containerElement.querySelector(`.${activeBullet}`).classList.remove(activeBullet);

            if (glideDir) {
                glideDir.classList.add(activeBullet);
            }
        }
    }

}

document.querySelectorAll('[data-image-slider]').forEach((item) => {
    new ImageSliderClass(item);
});
